import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { getSession } from '@/lib/session';
import { canAccessPrices } from '@/auth/consultaIdePricesAccess';

export default function RequireConsultaIdePrices({ children }: PropsWithChildren) {
  const session = typeof window !== 'undefined' ? getSession() : null;
  const user = session?.user;

  if (!canAccessPrices(user?.email, user?.role)) {
    return <Navigate to="/inventario" replace />;
  }

  return children;
}
